{
  "cta": {"action": "Anmelden"},
  "features": {
    "items": [
      {
        "desc": "Gehen Sie das Korpus Dokument für Dokument durch oder öffnen Sie ein Dokument in einer genauen Version.",
        "title": "Dokumente finden"
      },
      {
        "desc": "Markieren Sie Entitäten einheitlich nach gemeinsamen Richtlinien. Jede Annotation hält fest, wie sie entstand.",
        "title": "Präzise annotieren"
      },
      {
        "desc": "Erstellen Sie eine formale Ontologie der Strukturen und Beziehungen in Ihren Dokumenten.",
        "title": "Ein Datenmodell aufbauen"
      },
      {
        "desc": "Teilen Sie Durchläufe mit Kolleginnen und Kollegen, sehen Sie Änderungen im Review durch, bevor sie übernommen werden, und behalten Sie jede Version.",
        "title": "Zusammenarbeiten"
      }
    ]
  },
  "header": {"title": "DMW"},
  "hero": {
    "more": "Schritte ansehen",
    "start": "Anmelden",
    "title": "Dokumente annotieren und ein Datenmodell aufbauen"
  },
  "heroCard": {
    "annotatedDesc": "Personen, Orte, Daten …",
    "annotatedTitle": "Annotierte Entitäten",
    "doc": "Ein Dokument",
    "modelDesc": "Beziehungen und Struktur",
    "modelTitle": "Datenmodell"
  },
  "workflow": {
    "steps": [
      {"title": "Dokumente importieren"},
      {"title": "Entitäten annotieren"},
      {"title": "Ontologie aufbauen"}
    ]
  }
}
